import { postRequest, putRequest } from 'utils/axiosClient'

const userLookup = async (requestData) => {
	const response = await postRequest('api/lookup', requestData)
	return response.data
}

const createToken = (requestData) => {
	const response = postRequest('authenticate/createToken', requestData)
	return response
}

const updateConsent = (requestData) => {
	const response = putRequest('api/consent', requestData)
	return response
}

const lookupEstate = async (requestData) => {
	if (!requestData.email) {
		console.error('Email is missing in requestData.')
		throw new Error('Email is required in requestData.')
	}

	const response = await postRequest('api/lookupEstate', requestData)

	return {
		...response.data,
		email: window.btoa(requestData.email),
	}
}

export default { userLookup, createToken, updateConsent, lookupEstate }
